<div class="atn-date-range-content">
  <atn-ds-tag [text]="readableDateRangeSg()" />
</div>
